

export const wrapeth = {
  address: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619'
}

export const getEthMaticFactor = {
  contractName: 'MaticEscrow',
  method: 'ethmaticfactor',
  methodArgs: '',
};

// matic/weth bundle prices
export const getSmallBundlePriceEth = {
  contractName: 'MaticEscrow',
  method: 'smallbundlepriceEth',
  methodArgs: '',
};
export const getBigBundlePriceEth = {
  contractName: 'MaticEscrow',
  method: 'bigbundlepriceEth',
  methodArgs: '',
};
export const getMediumBundlePriceEth = {
  contractName: 'MaticEscrow',
  method: 'mediumbundlepriceEth',
  methodArgs: '',
};

// wrap eth bundles
export const getSmallBundleEth = {
  contractName: 'MaticEscrow',
  method: 'smallbundleEth',
  methodArgs: '',
};
export const getBigBundleEth = {
  contractName: 'MaticEscrow',
  method: 'bigbundleEth',
  methodArgs: '',
};
export const getMediumBundleEth = {
  contractName: 'MaticEscrow',
  method: 'mediumbundleEth',
  methodArgs: '',
};

// matic bundles
export const getSmallBundleMatic = {
  contractName: 'MaticEscrow',
  method: 'smallbundleMatic',
  methodArgs: '',
};
export const getBigBundleMatic = {
  contractName: 'MaticEscrow',
  method: 'bigbundleMatic',
  methodArgs: '',
};
export const getMediumBundleMatic = {
  contractName: 'MaticEscrow',
  method: 'mediumbundleMatic',
  methodArgs: '',
};

//  eth chain bundle prices
export const getBigBundleprice = {
  contractName: 'SolidEscrow',
  method: 'bigbundleprice',
  methodArgs: '',
};

export const getSmallBundleprice = {
  contractName: 'SolidEscrow',
  method: 'smallbundleprice',
  methodArgs: '',
};

// eth chain bundles
export const getBigBundle = {
  contractName: 'SolidEscrow',
  method: 'bigbundle',
  methodArgs: '',
};

export const getSmallBundle = {
  contractName: 'SolidEscrow',
  method: 'smallbundle',
  methodArgs: '',
};


